import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, MapPin, ArrowRight, Quote } from "lucide-react";
import { featuredAPI, resolveImg } from "../lib/api";

export default function ListingOfMonthBanner() {
  const [data, setData] = useState(null);

  useEffect(() => {
    featuredAPI
      .listingOfMonth()
      .then((d) => setData(d || null))
      .catch(() => setData(null));
  }, []);

  if (!data || !data.listing) return null;
  const l = data.listing;
  const seller = data.seller || {};

  return (
    <section className="max-w-7xl mx-auto px-4 pt-6" data-testid="listing-of-month-banner">
      <div className="relative overflow-hidden rounded-3xl border-2 border-amber-300 bg-gradient-to-br from-amber-50 via-orange-50 to-amber-100 shadow-md">
        <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-amber-300/30 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-20 -left-20 w-72 h-72 rounded-full bg-[#e86a24]/15 blur-3xl pointer-events-none" />

        <div className="grid md:grid-cols-[1.1fr_1fr] gap-0 relative">
          <Link to={`/annuncio/${l.id}`} className="relative aspect-[4/3] md:aspect-auto md:min-h-[300px] bg-slate-200 overflow-hidden group">
            {l.images?.[0] ? (
              <img
                src={resolveImg(l.images[0])}
                alt={l.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
            ) : (
              <div className="w-full h-full bg-slate-300" />
            )}
            <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-amber-400 text-amber-950 text-[10px] font-black uppercase tracking-wider px-3 py-1.5 rounded-full shadow-lg">
              <Crown className="w-3.5 h-3.5" /> Annuncio del Mese
            </div>
          </Link>

          <div className="p-6 md:p-8 flex flex-col justify-center">
            <div className="text-[11px] font-black uppercase tracking-widest text-[#e86a24] mb-1">Scelta della Redazione</div>
            <h2 className="text-2xl md:text-3xl font-black text-[#1d3d3a] leading-tight">
              {l.title}
            </h2>
            <div className="mt-2 flex items-center gap-3 flex-wrap text-sm">
              <span className="font-black text-[#e86a24] text-xl">€ {l.price}</span>
              <span className="inline-flex items-center gap-1 text-slate-600">
                <MapPin className="w-3.5 h-3.5" />
                {l.castello}
              </span>
              {seller.name && <span className="text-slate-500 text-xs">· {seller.name}</span>}
            </div>

            {data.note && (
              <div className="mt-4 bg-white/70 backdrop-blur border border-amber-200 rounded-xl p-3 text-sm text-slate-700 italic flex gap-2">
                <Quote className="w-4 h-4 shrink-0 text-amber-500 mt-0.5" />
                <span>{data.note}</span>
              </div>
            )}

            <Link
              to={`/annuncio/${l.id}`}
              className="mt-5 inline-flex items-center gap-2 self-start bg-[#1d3d3a] hover:bg-[#0e2625] text-white font-bold text-sm px-5 h-11 rounded-full transition-colors"
              data-testid="listing-of-month-cta"
            >
              Scopri di più
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
